export default "__VITE_ASSET__72d8f1d5__"